// Localization is based on '@ngx-translate/core';
// Please be familiar with official documentations first => https://github.com/ngx-translate/core

import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface Locale {
  lang: string;
  data: any;
}

const LOCALIZATION_LOCAL_STORAGE_KEY = 'language';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  // Private properties
  private langIds: any = [];

  constructor(private translate: TranslateService) {
    // add new langIds to the list
    this.translate.addLangs(['en']);

    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang('en');
  }

  loadTranslations(...args: Locale[]): void {
    const locales = [...args];

    locales.forEach((locale) => {
      // use setTranslation() with the third argument set to true
      // to append translations instead of replacing them
      this.translate.setTranslation(locale.lang, locale.data, true);
      this.langIds.push(locale.lang);
    });

    // add new languages to the list
    this.translate.addLangs(this.langIds);
    this.translate.use(this.getSelectedLanguage());
    this.changeDocumentDirection();
  }

  setLanguage(lang: string) {
    if (lang) {
      this.translate.use(this.translate.getDefaultLang());
      this.translate.use(lang);
      localStorage.setItem(LOCALIZATION_LOCAL_STORAGE_KEY, lang);
      this.changeDocumentDirection();
    }
  }

  changeDocumentDirection() {
    const body = document.getElementsByTagName('body')[0] as HTMLBodyElement
    if (this.getSelectedLanguage() === 'ar') {
      const changePlacement = document.querySelectorAll('div[data-kt-menu-placement="bottom-start"]')
      const changePlacementElements = document.querySelectorAll('div[data-kt-menu-placement="right-start"]')
      // const toolbar = document.getElementById('kt_content') as HTMLElement
      body.dir = 'rtl'
      body.style.direction = 'rtl'
      // Remove the CSS variables and classes
      // body.style.setProperty('--bs-toolbar-height', null);
      // body.style.setProperty('--bs-toolbar-height-tablet-and-mobile', null);
      // body.classList.remove('header-fixed','header-tablet-and-mobile-fixed','toolbar-fixed','toolbar-tablet-and-mobile-fixed','aside-enabled','aside-fixed')
      // toolbar.style.padding = '0px'
      body.classList.add('dir-rtl')
      changePlacement.forEach(ele => {
        ele.removeAttribute('data-kt-menu-placement')
        ele.setAttribute('data-kt-menu-placement', 'bottom-end')
      })
      changePlacementElements.forEach(ele => {
        ele.removeAttribute('data-kt-menu-placement')
        ele.setAttribute('data-kt-menu-placement', 'left-start')
      })

    } else {
      body.dir = 'ltr'
      body.style.direction = 'ltr'
      const changePlacement = document.querySelectorAll('div[data-kt-menu-placement="bottom-end"]')
      const changePlacementElements = document.querySelectorAll('div[data-kt-menu-placement="left-start"]')
      body.classList.remove('dir-rtl')
      changePlacement.forEach(ele => {
        ele.removeAttribute('data-kt-menu-placement')
        ele.setAttribute('data-kt-menu-placement', 'bottom-start')
      })
      changePlacementElements.forEach(ele => {
        ele.removeAttribute('data-kt-menu-placement')
        ele.setAttribute('data-kt-menu-placement', 'right-start')
      })
      // Reset the CSS variables and classes
      // body.style.setProperty('--bs-toolbar-height', '55px');
      // body.style.setProperty('--bs-toolbar-height-tablet-and-mobile', '55px');
      // body.classList.add('header-fixed','header-tablet-and-mobile-fixed','toolbar-enabled','toolbar-fixed','toolbar-tablet-and-mobile-fixed','aside-enabled','aside-fixed')

    }
  }

  /**
   * Returns selected language
   */
  getSelectedLanguage(): any {
    return (
      localStorage.getItem(LOCALIZATION_LOCAL_STORAGE_KEY) ||
      this.translate.getDefaultLang()
    );
  }
}
